import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private httpClient: HttpClient) { }

  decodeToken(token: string): string {
    return jwt_decode(token);
  }

  sendForRecoveryPasswordEmail(email: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.httpClient.post<any>('/users/recovery-password',
      {
        email: email
      }, { headers }
    )
  }

  sendForUpdatePassword(body: any) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.httpClient.put<any>('/users/update-password', body, { headers })
  }

  sendPhoneNumberForOTP(phoneNumber: string) {
    return this.httpClient.post<any>('/otp-authenticate/send', {
         phoneNumber: phoneNumber
    });
  }

  /*verifyOTP(phoneNumber: string, otp: string) {
    return this.httpClient.post<any>('/otp-authenticate/verify', {
      phoneNumber: phoneNumber,
      code: otp  
    });
  }*/

  CheckCustomerDataExists(body: any, signupToken: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.httpClient.post<any>('/billingCustomer/customerDataExists', { token: signupToken, customer: body }, { headers });
  }

  signUpExistingCustomer(body: any){
    const headers = new HttpHeaders().set('Accept', 'application/json');
    return this.httpClient.post<any>('/billingCustomer/signupExistingCustomer', body , {
      headers,
      observe: 'response',
    });
  }

  verifyEmail(body: any){
    const headers = new HttpHeaders().set('Accept', 'application/json');
    return this.httpClient.post<any>('/customerStore/verifyEmail', body, {
      headers,
      observe: 'response',
    });
  }
}



